const LinkList = [
  {
    id: 1,
    name: 'Marketplace',
    url: 'market-place',
  },
  {
    id: 2,
    name: 'News/Article',
    url: '#',
  },
  {
    id: 3,
    name: 'Tender',
    url: '#',
  },
];

export default LinkList;
